import { theme } from '@corva/ui/config';
import { LOCAL_STORAGE_APP_THEME_KEY } from '@corva/ui/constants/localStorageKeys';
import { setThemeVariables } from '@corva/ui/utils/themeVariables';

import { THEMES } from '~/constants/theme';

const getThemeByName = (themeName: string) => {
  return themeName === THEMES.LIGHT ? theme.lightTheme : theme.darkTheme;
};

const initialThemeName = localStorage.getItem(LOCAL_STORAGE_APP_THEME_KEY);
setThemeVariables(initialThemeName !== THEMES.LIGHT);

class ThemeStore {
  private theme = getThemeByName(initialThemeName);
  private listener: (() => void) | null = null;

  setThemeByName = (newThemeName: string) => {
    try {
      this.theme = getThemeByName(newThemeName);
      const isDarkTheme = newThemeName !== THEMES.LIGHT;
      localStorage.setItem(LOCAL_STORAGE_APP_THEME_KEY, isDarkTheme ? THEMES.DARK : THEMES.LIGHT);
      setThemeVariables(isDarkTheme);
      this.listener?.();
    } catch (err) {
      console.error('Error setting theme:', err);
    }
  };

  getTheme = () => this.theme;

  subscribe = (listener: () => void) => {
    this.listener = listener;
    return () => {
      this.listener = null;
    };
  };
}

export const themeStore = new ThemeStore();
